<template>
  <div class="production-modal" v-loading="loading">
    <div v-if="orgAllSelect.length || listDatas.length" style="height: 100%">
      <!-- 分公司账号 -->
      <div class="bottom-ul bottom-ul-fen" v-if="orgAllSelect.length">
        <div v-for="(itemb, indexb) in orgAllSelect" :key="indexb">
          <div
            class="ul-fendiv"
            :class="{ 'ul-fendiv-one': indexb == 0 }"
            v-if="itemb.list && itemb.list.length"
          >
            <div
              v-for="(item, index) in itemb.list"
              :key="index"
              class="bottom-lis"
              @mouseenter="getInfoDataBig(item, index, indexb)"
            >
              <!-- 正常状态 -->
              <div
                class="t_c cursor bottom-divs"
                :class="item.status == '3' ? 'bottom-red' : 'bottom-green'"
              >
                <img
                  class="dapeng_img"
                  src="@/assets/image/home/dapeng_img.png"
                  alt=""
                />
                <div class="flex flex_a_end flex_ju_c bottom-names">
                  <img
                    v-if="item.status == '3'"
                    class="icon_green"
                    src="@/assets/image/home/icon_red.png"
                    alt=""
                  />
                  <img
                    v-else
                    class="icon_green"
                    src="@/assets/image/home/icon_green.png"
                    alt=""
                  />
                  <span class="font_16 c_45 bottom-name">{{
                    item.orgName
                  }}</span>
                </div>
              </div>
              <!-- 详情状态 -->
              <div
                class="font_14 c_45 cursor bottom-infos flex flex_col flex_ju_c"
                :class="item.status == '3' ? 'bottom-red' : 'bottom-green'"
              >
                <div
                  v-if="item.infos && item.infos.length"
                  :class="{ itInfoFlex: item.infos.length <= 4 }"
                >
                  <div
                    v-for="(items, indexs) in item.infos"
                    :key="indexs"
                    style="line-height: 2"
                    :class="{ 'dis-none': !items.CODE }"
                  >
                    <template v-if="items.CODE"
                      >{{ items.CODENAME }}：{{ items.VALUE }}</template
                    >
                  </div>
                </div>
                <div class="no-word font_16" v-else>暂无数据</div>
              </div>
            </div>
            <div class="fen-name">{{ itemb.orgName }}</div>
          </div>
        </div>
      </div>
      <!-- 直接是网点账号 -->
      <div class="bottom-ul" v-if="listDatas.length">
        <div
          v-for="(item, index) in listDatas"
          :key="index"
          class="bottom-lis"
          @mouseenter="getInfoData(item, index)"
        >
          <!-- 正常状态 -->
          <div
            class="t_c cursor bottom-divs"
            :class="item.status == '3' ? 'bottom-red' : 'bottom-green'"
          >
            <img
              class="dapeng_img"
              src="@/assets/image/home/dapeng_img.png"
              alt=""
            />
            <div class="flex flex_a_end flex_ju_c bottom-names">
              <img
                v-if="item.status == '3'"
                class="icon_green"
                src="@/assets/image/home/icon_red.png"
                alt=""
              />
              <img
                v-else
                class="icon_green"
                src="@/assets/image/home/icon_green.png"
                alt=""
              />
              <span class="font_16 c_45 bottom-name">{{ item.orgName }}</span>
            </div>
          </div>
          <!-- 详情状态 -->
          <div
            class="font_14 c_45 cursor bottom-infos flex flex_col flex_ju_c"
            :class="item.status == '3' ? 'bottom-red' : 'bottom-green'"
          >
            <div
              v-if="item.infos && item.infos.length"
              :class="{ itInfoFlex: item.infos.length <= 4 }"
            >
              <div
                v-for="(items, indexs) in item.infos"
                :key="indexs"
                style="line-height: 2"
                :class="{ 'dis-none': !items.CODE }"
              >
                <template v-if="items.CODE"
                  >{{ items.CODENAME }}：{{ items.VALUE }}</template
                >
              </div>
            </div>
            <div class="no-word font_16" v-else>暂无数据</div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="table-empty flex flex_col flex_ju_c flex_a_c bottom-empty"
      v-else
    >
      <img class="table-noimg" src="@/assets/image/home/img_none.png" alt="" />
      <div class="table-emptyword">暂无生产区域</div>
    </div>
  </div>
</template>

<script>
import { set } from "vue";
export default {
  data() {
    return {
      orgAllSelect: [], // 分公司网点数据
      // 数据
      listDatas: [],
      loading: true,
    };
  },
  mounted() {
    // 请求列表数据
    // this.loadData()
    // 如果是分公司账号，先请求公共接口获取网点数据
    if (this.isShowAllSelect) {
      // 获取上面的生产区域信息
      this.getAllOrgids();
    } else {
      // 直接获取大棚数据
      this.loadData();
    }
  },
  computed: {
    // 是否是分公司账号
    isShowAllSelect() {
      let userOrg = this.getItem("wlwOrg") || {};
      let userOrgs = JSON.parse(userOrg);
      if (userOrgs.orgLevel == 2) {
        return true;
      }
      return false;
    },
  },
  methods: {
    getAllOrgids() {
      let userInfo = this.getItem("wlwUserInfo") || {};
      let userInfos = JSON.parse(userInfo);
      let params = {
        parentOrgId: userInfos.orgId,
        type: "2",
      };
      this.listDatas = [];
      this.$http
        .getAction(this.$api.findChildOrgByParentOrgId, params)
        .then((res) => {
          if (res.meta.success) {
            let datas = res.data || [];
            this.orgAllSelect = datas || [];
            if (datas && datas.length) {
              for (let i = 0; i < datas.length; i++) {
                this.loadData(true, datas[i], i);
              }
            } else {
              setTimeout(() => {
                this.loading = false;
              }, 200);
            }
          } else {
            this.orgAllSelect = [];
            setTimeout(() => {
              this.loading = false;
            }, 200);
          }
        })
        .catch(() => {
          this.orgAllSelect = [];
          setTimeout(() => {
            this.loading = false;
          }, 200);
        });
    },
    // 加载列表
    loadData(isFen = false, items, i) {
      let userInfo = this.getItem("wlwUserInfo") || {};
      let userInfos = JSON.parse(userInfo);
      let params = {
        orgId: "",
      };
      if (isFen) {
        params.orgId = items.orgId;
      } else {
        params.orgId = userInfos.orgId;
      }
      this.$http
        .getAction(this.$api.findKzxByOrgCode, params)
        .then((res) => {
          if (res && res.length) {
            let datas = res || [];
            // 如果是分公司
            if (isFen) {
              this.$set(this.orgAllSelect[i], "list", datas);
            } else {
              this.listDatas = datas || [];
            }
          } else {
            this.listDatas = [];
          }
        })
        .catch((err) => {
          this.listDatas = [];
        })
        .finally((err) => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    // 鼠标移入事件，请求加载具体的数据
    getInfoData({ orgId }, index) {
      if (this.listDatas[index]["infos"] && this.listDatas[index]["infos"])
        return;
      let params = {
        orgId: orgId,
      };
      this.$http.getAction(this.$api.kzxData, params).then((res) => {
        if (res && res.length) {
          this.$set(this.listDatas[index], "infos", res);
        } else {
          this.$set(this.listDatas[index], "infos", []);
        }
      });
    },
    getInfoDataBig({ orgId }, index, indexb) {
      if (this.orgAllSelect[indexb]["list"][index]["infos"]) return;
      let params = {
        orgId: orgId,
      };
      this.$http.getAction(this.$api.kzxData, params).then((res) => {
        if (res && res.length) {
          this.$set(this.orgAllSelect[indexb]["list"][index], "infos", res);
        } else {
          this.$set(this.orgAllSelect[indexb]["list"][index], "infos", []);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.production-modal {
  height: 83%;
  // 列表
  .bottom-ul {
    // width: 19.65rem;
    margin-top: 0.21rem;
    margin-left: 0.31rem;
    margin-right: 0.05rem;
    height: 100%;
    overflow-y: scroll;
    text-align: left;
    // 背景
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background-color: transparent;
      border-radius: 4px;
    }
    // 背景
    &::-webkit-scrollbar-track {
      width: 8px;
      height: 8px;
      background-color: transparent;
      border-radius: 4px;
    }
    // 滚动条
    &::-webkit-scrollbar-thumb {
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background-color: #d9d9d9;
    }
    .bottom-lis {
      width: 16%;
      height: 2.44rem;
      display: inline-block;
      margin-left: 0.8%;
      &:nth-child(n + 7) {
        margin-top: 0.26rem;
      }
      &:nth-child(6n + 1) {
        margin-left: 0;
      }
      position: relative;
      &:hover {
        .bottom-divs {
          opacity: 0;
        }
        .bottom-infos {
          opacity: 1;
        }
      }
    }
  }

  // 分公司账号
  .bottom-ul-fen {
    margin-left: 0.25rem;
    padding-top: 0.21rem;
    .ul-fendiv {
      width: 99.5%;
      border: 1px solid #ebebeb;
      // padding: 0.3rem 0.06rem 0.17rem 0.11rem;
      padding: 1.25vw 0.26vw 0.73vw 0.46vw;
      position: relative;
      margin-top: 1.35vw;
      &.ul-fendiv-one {
        margin-top: 0;
      }
      // 网点名称
      .fen-name {
        position: absolute;
        font-size: 0.2rem;
        color: #454545;
        background-color: #fff;
        top: -0.09rem;
        left: 0.41rem;
        padding: 0 0.13rem 0 0.16rem;
      }
    }
  }
  // 正常状态
  .bottom-green {
    background: #e7f1f3;
  }
  // 异常状态
  .bottom-red {
    background: #fcecec;
  }
  // 名称状态
  .bottom-divs {
    width: 100%;
    height: 100%;
    border-radius: 0.13rem;
    padding-top: 0.3rem;
    opacity: 1;
    transition: opacity 0.5s;
    .dapeng_img {
      width: 2.25rem;
      height: 1.19rem;
    }
    .bottom-names {
      margin-top: 0.13rem;
      .icon_green {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.31rem;
      }
      .bottom-name {
        padding-bottom: 0.05rem;
        letter-spacing: 0.01rem;
      }
    }
  }
  // 详情
  .bottom-infos {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 0.13rem;
    text-align: left;
    padding: 0.2rem 0.21rem 0.19rem;
    opacity: 0;
    transition: opacity 1s;
    & > div {
      width: 100%;
      height: 100%;
      line-height: 2;
      // display: flex;
      // flex-direction: column;
      // justify-content: center;
      overflow: scroll;
      // padding-top: 0.25rem;
      // 背景
      &::-webkit-scrollbar {
        width: 8px;
        height: 0px;
        background-color: transparent;
        border-radius: 4px;
      }
      // 背景
      &::-webkit-scrollbar-track {
        width: 8px;
        height: 8px;
        background-color: transparent;
        border-radius: 4px;
      }
      // 滚动条
      &::-webkit-scrollbar-thumb {
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background-color: #d9d9d9;
      }

      .dis-none {
        display: none;
      }
    }
    .itInfoFlex {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .no-word {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
  }
  .bottom-empty {
    padding-top: 5%;
    .table-noimg {
      width: 12.5vw;
    }
    .table-emptyword {
      color: #797979;
      margin-top: 0.4rem;
      font-size: 0.17rem;
    }
  }
}
</style>
